<template>
  <div>
    <div data-cy="form-label" class="b-dialog__top-panel">
      <h2>{{$t('CONTENT.contract.contract_editing')}}</h2>
      <button class="b-btn b-btn_border_none" @click="closeContractEditingDialog">
        <dynamic-icon icon="close" />
      </button>
    </div>
    <form class="b-form b-dialog__form">
      <server-error :error="error" />
      <div v-for="(lowValueAsset, lowValueAssetsIndex) in currentLowValueAssets">
        <LowValueAssetsItemEdit
          :lowValueAsset="lowValueAsset"
          :lowValueAssetsIndex="lowValueAssetsIndex"
          :settingsCurrencyCode="settingsCurrencyCode"
          :availableAssetIdsForGroup="availableAssetIds"
          :lowValueAssetsLength="lowValueAssets.length"
          :validationErrors="validationLowValueAsset[lowValueAssetsIndex]"
          @newAssetSelected="newAssetSelectedForGroup"
          @newAssetCreated="newAssetCreatedForGroup"
          @deleteAsset="onDeleteAsset"
        ></LowValueAssetsItemEdit>
      </div>
      <div class="row mt-5">
        <div class="col-5">
          <div class="b-form__container">
            <button
              type="button"
              class="b-btn"
              :disabled="isDisabledSaveLowValueAssetsEdit"
              @click="addLowValueAsset"
            >
              <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
              {{$t('CONTENT.assets.add_asset')}}
            </button>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-6 offset-6">
          <div
            class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
          >
            <button
              data-cy="save-button"
              class="b-btn b-btn_type_primary"
              type="submit"
              :disabled="isDisabledSaveLowValueAssetsEdit"
              @click="onSubmit"
            >{{$t('CONTENT.save')}}</button>
            <button
              class="b-btn b-btn_type_empty m-2"
              @click.prevent="closeContractEditingDialog"
            >{{$t('CONTENT.cancel')}}</button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import dateConverter from "../../../../../utils/converters/date.converter";
  import LowValueAsset from "../../../../../models/alternativeContract/LowValueAsset";
  import LowValueAssetsItemEdit from "./LowValueAssetsItemEdit";

  export default {
    components: {
      LowValueAssetsItemEdit,
    },
    props: {
      lowValueAssets: {
        type: Array
      },
    },
    data() {
      return {
        error: null,
        currentLowValueAssets: [],
        availableAssetIds: [],
        validationLowValueAsset: [],
      };
    },
    created() {
      this.updateFormData();

      if (this.availableAssetIds.length === 0) {
        this.availableAssetIds = [...this.getAssets];
      }
    },
    watch: {
      lowValueAssets: {
        immediate: true,
        handler() {
          this.updateFormData();
        }
      },
    },
    computed: {
      ...mapGetters (["getContractSettings"]),
      ...mapGetters (["getAssets"]),
      settingsCurrencyCode() {
        return this.getContractSettings.currencyCode;
      },
      isDisabledAddPeriodSpendings() {
        for (let i = 0; i < this.currentLowValueAssets.length; i++) {
          if (
            this.currentLowValueAssets[i].startDate === null ||
            this.currentLowValueAssets[i].endDate === null ||
            this.currentLowValueAssets[i].sum === null
          ) {
            return true;
          }
        }

        return false;
      },
      isDisabledSaveLowValueAssetsEdit() {
        for (let i = 0; i < this.currentLowValueAssets.length; i++) {
          for (let j = 0; j < this.currentLowValueAssets[i].periodSpendings.length; j++) {
            if (
              this.currentLowValueAssets[i].periodSpendings[j].startDate === null ||
              this.currentLowValueAssets[i].periodSpendings[j].endDate === null ||
              this.currentLowValueAssets[i].periodSpendings[j].sum === null
            ) {
              return true;
            }
          }
        }

        return false;
      },
    },
    methods: {
      updateFormData() {
        if (this.lowValueAssets.length !== 0) {
          this.currentLowValueAssets = _.cloneDeep(this.lowValueAssets);
        }
      },
      addLowValueAsset() {
        this.currentLowValueAssets.push (LowValueAsset.createNew ());
      },
      closeContractEditingDialog() {
        this.currentLowValueAssets = _.cloneDeep(this.lowValueAssets);
        this.$emit("close");
      },
      newAssetCreatedForGroup(data) {
        const newAsset = this.getAssets.find (a => a.idInDB === data.new);
        const oldAsset = this.getAssets.find (a => a.idInDB === data.old);
        this.availableAssetIds.push (newAsset);

        const ckeckOldAsset = this.availableAssetIds.find (a => a.idInDB === data.old);
        if (ckeckOldAsset === null) {
          this.availableAssetIds.push (oldAsset);
        }
      },
      newAssetSelectedForGroup(data) {
        // Return previous asset to collection
        const oldAsset = this.getAssets.find (a => a.idInDB === data.old);
        const ckeckOldAsset = this.availableAssetIds.find (a => a.idInDB === data.old);
        if (ckeckOldAsset === null && oldAsset !== null) {
          this.availableAssetIds.push (oldAsset);
        }

        const choosenAsset = this.getAssets.find (a => a.idInDB === data.old);
        if (choosenAsset != null) {
          this.availableAssetIds.push(choosenAsset);
        }

        // remove new selected asset from collection if exist
        const neededAsset = this.availableAssetIds.find (a => a.idInDB === data.new);
        if (neededAsset !== null) {
          const neededAssetIndex = this.availableAssetIds.indexOf (neededAsset);
          this.availableAssetIds.splice(neededAssetIndex, 1);
        }
      },
      onDeleteAsset(asset) {
        for (let i = 0; i < this.currentLowValueAssets.length; i++) {
          if(this.currentLowValueAssets[i].assetId === asset) {
            this.currentLowValueAssets.splice(i, 1);
          }
        }
        this.$store.commit ("EDIT_ALTERNATIVE_CONTRACT_VALUE", {
          name: "lowValueAssets",
          value: this.lowValueAssets
        });
      },
      onSubmit(e) {
        e.preventDefault();
        if (!this.validate()) return;
        this.$emit('onSaveEditing', this.currentLowValueAssets);
        this.$emit("close");
        this.currentLowValueAssets = _.cloneDeep(this.lowValueAssets);
      },
      validate() {
        const lowValueAsset = this.currentLowValueAssets;
        this.validateLowValueAssets(lowValueAsset);
        return !this.validationLowValueAsset.some(e => e.assetId || e.periodSpendings.some(p => p.length > 0));
      },
      validateLowValueAssets(lowValueAssets) {
        this.validationLowValueAsset = [];
        for (const lowValueAsset of lowValueAssets) {
          this.validationLowValueAsset.push({ assetId: !lowValueAsset.assetId, periodSpendings: this.validatePeriodSpendings(lowValueAsset.periodSpendings) });
        }
      },
      validatePeriodSpendings(periodSpendings) {
        const validationPeriodSpendings = [];
        for (const [index, periodSpending] of periodSpendings.entries()) {
          this.$set(validationPeriodSpendings, index, []);
          if (!periodSpending.startDate) {
            validationPeriodSpendings[index].push('startDate');
          }
          if (!periodSpending.endDate) {
            validationPeriodSpendings[index].push('endDate');
          }
          if (periodSpending.sum === null || periodSpending.sum === undefined) {
            validationPeriodSpendings[index].push('sum');
          }
        }
        return validationPeriodSpendings;
      }
    }
  };
</script>
